import type {SvgIconProps} from '@mui/material';
import {SvgIcon} from '@mui/material';
import {memo} from 'react';

export const Criteria = memo((props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{
        width: 'var(--size, 24px)',
        height: 'var(--size, 24px)',
        ...(props.style ?? {}),
      }}
    >
      <path d="M5 6.91667C5 6.40964 5.39102 6 5.875 6H16.375C16.859 6 17.25 6.40964 17.25 6.91667C17.25 7.4237 16.859 7.83333 16.375 7.83333H5.875C5.39102 7.83333 5 7.4237 5 6.91667ZM6.75 11.5C6.75 10.993 7.14102 10.5833 7.625 10.5833H18.125C18.609 10.5833 19 10.993 19 11.5C19 12.007 18.609 12.4167 18.125 12.4167H7.625C7.14102 12.4167 6.75 12.007 6.75 11.5ZM17.25 16.0833C17.25 16.5904 16.859 17 16.375 17H5.875C5.39102 17 5 16.5904 5 16.0833C5 15.5763 5.39102 15.1667 5.875 15.1667H16.375C16.859 15.1667 17.25 15.5763 17.25 16.0833Z" />
    </SvgIcon>
  );
});
Criteria.displayName = 'Criteria';
